import React from 'react';

import Layout from 'layouts/Layout';
import OcrOrderMatch from './OcrOrderMatch';

const OcrOrderMatchLayout = ({ match }) => <Layout component={OcrOrderMatch} match={match} />;

export default OcrOrderMatchLayout;
